export default __webpack_public_path__ + "static/media/01__o_preview_0.9f24553e.jpg";